import { render, staticRenderFns } from "./MyBookmarks.vue?vue&type=template&id=2321c713"
import script from "./MyBookmarks.vue?vue&type=script&lang=js"
export * from "./MyBookmarks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports